import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

import './styles.scss'

const Help = () => {
    const user = useSelector((state) => state.firebase.profile);
    const [text, setText] = useState('')
    const [loading, setLoading] = useState(false)
    const [log, setLog] = useState(null)

    useEffect(() => {
        let logTimer
        if (log) {
            logTimer = setTimeout(() => setLog(null), 7000)
        }
        return () => {
            clearTimeout(logTimer)
        }
    }, [log])

    const handleHelpMessageSend = () => {
        const data = JSON.stringify({
            email: 'walt+unitysupport@newbirddesign.com',
            subject: 'Need Help | Unity Mobile App',
            text,
            address: user.address,
            firstName: user.firstName,
            lastName: user.lastName,
        });
        setLoading(true);
        const sendEmail = async () => {
            try {
                const response = await fetch(
                    'https://us-central1-unity-61a0c.cloudfunctions.net/httpEmail',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                        },
                        body: data,
                    },
                );
                setLoading(false);
                setText('')
                if (response.status === 200) {
                    setLog('Thanks for the question. We\'ll reach out to your email associated to this account shortly!')
                }
            } catch (error) {
                setLoading(true);
                alert(error);
            }
        };
        sendEmail();
    };
    return (
        <div className='help help__container'>
            <h1 className='help__title'>Happy to Help</h1>
            <p className='help__text'>Ask you questions below, and we will email
                you back as soon as possible. Thank you</p>
            <textarea rows='20' name="text" className='help__textarea'
                      placeholder='Question here...' onChange={(e) => {
                setText(e.target.value)
            }} value={text}/>
            <div>
                <button className={`help__button-${loading ? 'disabled' : 'regular'}`} onClick={handleHelpMessageSend}>Submit</button>
            </div>
            {log && <p>{log}</p>}
        </div>
    )
}

export default Help